import { PropsWithChildren } from 'react';
import classNames from 'classnames';

type Props = {
  disabled?: boolean;
  onClick: () => void;
};

const QuantityButton = ({
  disabled,
  onClick,
  children
}: PropsWithChildren<Props>) => (
  <button
    type="button"
    disabled={disabled}
    className={classNames(
      'px-1.5 py-1',
      disabled && 'opacity-30 cursor-not-allowed'
    )}
    onClick={onClick}
  >
    {children}
  </button>
);

export default QuantityButton;
